import React from 'react';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';


const Index = () => {
    const { publications } = usePage().props;
    const {
        data,
    } = publications;
    return (
        <div>
            <h1 className="mb-8 text-3xl font-bold">Publications</h1>
            <div className="flex items-center justify-between mb-6">

                <InertiaLink
                    className="btn-indigo focus:outline-none"
                    href={route('publications.create')}
                >
                    <span>Create</span>
                    <span className="hidden md:inline"> Publication</span>
                </InertiaLink>
            </div>
            <div className="overflow-x-auto bg-white rounded shadow">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="font-bold text-left">
                        <th className="px-6 pt-5 pb-4">Title</th>
                        <th className="px-6 pt-5 pb-4">Year</th>
                        <th className="px-6 pt-5 pb-4" colSpan="2">
                           Action
                        </th>

                    </tr>
                    </thead>
                    <tbody>
                    {data.map(({ id, title, description, doi, authors, year}) => (
                        <tr
                            key={id}
                            className="hover:bg-gray-100 focus-within:bg-gray-100"
                        >
                            <td className="border-t">
                                <InertiaLink
                                    href={route('publications.edit', id)}
                                    className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                                >
                                    {title}

                                </InertiaLink>
                            </td>


                            <td className="border-t">
                                <InertiaLink
                                    tabIndex="-1"
                                    href={route('publications.edit', id)}
                                    className="flex items-center px-6 py-4 focus:text-indigo focus:outline-none"
                                >
                                    {year}
                                </InertiaLink>
                            </td>
                            <td className="w-px border-t">
                                <InertiaLink
                                    tabIndex="-1"
                                    href={route('publications.edit', id)}
                                    className="flex items-center px-4 focus:outline-none"
                                >
                                    <Icon
                                        name="cheveron-right"
                                        className="block w-6 h-6 text-gray-400 fill-current"
                                    />
                                </InertiaLink>
                            </td>
                        </tr>
                    ))}
                    {data.length === 0 && (
                        <tr>
                            <td className="px-6 py-4 border-t" colSpan="4">
                                No publications found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

Index.layout = page => <Layout title="Publications" children={page} />;

export default Index;
